import { IGlobalItem } from '../types';
import { useForm } from 'react-hook-form';
import { ButtonContainer } from '../../ButtonContainer/ButtonContainer';
import { PrimaryButton, SecondaryButton } from '@weareopenr/component-library';
import { IOptionGroupValues } from 'src/components/CreateOptionGroupModal/types';
import { OptionGroupPricing } from 'src/components/OptionGroupPricing';

interface IGlobalItemBundlePricingProps {
  wizardOnSubmit: (data: Partial<IGlobalItem>) => void;
  wizardItem: Partial<IGlobalItem>;
  goBack: () => void;
  isSubmitting: boolean;
}

export const GlobalItemBundlePricing = ({
  wizardOnSubmit,
  wizardItem,
  goBack,
  isSubmitting,
}: IGlobalItemBundlePricingProps) => {
  const formFields = useForm<IOptionGroupValues>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    defaultValues: {
      name: wizardItem.modifier_groups?.[0]?.name,
      modifiers: wizardItem.modifier_groups?.[0]?.modifiers,
      price_scheme_ids: wizardItem.price_scheme_ids,
    },
  });

  const {
    handleSubmit,
    formState: { isSubmitting: isFormSubmitting },
  } = formFields;

  const onFormSubmit = async (data: IOptionGroupValues) => {
    wizardOnSubmit({ ...wizardItem, modifier_groups: [{ ...wizardItem.modifier_groups[0], ...data }] });
  };

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <OptionGroupPricing formReturn={formFields} />

      <ButtonContainer
        left={
          <SecondaryButton type="button" size="full-width" buttonStyle="outline" onClick={goBack}>
            Back
          </SecondaryButton>
        }
        right={
          <PrimaryButton size="full-width" type="submit" loading={isSubmitting || isFormSubmitting}>
            Save
          </PrimaryButton>
        }
      />
    </form>
  );
};
